query GetPinnedContestsQuery {
  contests(first: 1, filter: { isPinned: true }) {
    edges {
      node {
        id
        shortTitle
        slug
      }
    }
  }
  contestsToJudge: contests(filter: { isCurrentUserJudging: true }) {
    edges {
      node {
        id
        shortTitle
        slug
      }
    }
  }
}
